import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
import { SPRING_SPOTLIGHT_GATE } from '../constants/gates';
import { SCOPE_SUPER_ADMIN, SCOPE_MULTI_ACCOUNT_COPY_ASSETS_WRITE } from '../constants/scopes';
export function useHasAssetCopierAccess() {
  const {
    gates,
    user
  } = userInfoSync();
  const hasSpringSpotlightGate = useMemo(() => (gates === null || gates === void 0 ? void 0 : gates.includes(SPRING_SPOTLIGHT_GATE)) || false, [gates]);
  const isSuperAdmin = useMemo(() => (user === null || user === void 0 ? void 0 : user.scopes.includes(SCOPE_SUPER_ADMIN)) || false, [user]);
  const hasCopyAssetsWriteScope = useMemo(() => (user === null || user === void 0 ? void 0 : user.scopes.includes(SCOPE_MULTI_ACCOUNT_COPY_ASSETS_WRITE)) || false, [user]);
  const hasAssetCopierAccess = useMemo(() => hasSpringSpotlightGate && (isSuperAdmin || hasCopyAssetsWriteScope), [hasSpringSpotlightGate, isSuperAdmin, hasCopyAssetsWriteScope]);
  return {
    hasAssetCopierAccess,
    hasSpringSpotlightGate,
    isSuperAdmin,
    hasCopyAssetsWriteScope
  };
}